export function getAppointmentStart(appointment) {
  return new Date(appointment.scheduled_at);
}

export function getAppointmentEnd(appointment) {
  return new Date(getAppointmentStart(appointment).getTime() + Number(appointment.duration_minutes || 0) * 60000);
}

export function getAppointmentTimingState(appointment, now = new Date()) {
  const start = getAppointmentStart(appointment).getTime();
  const end = getAppointmentEnd(appointment).getTime();
  const current = now.getTime();

  if (current < start) {
    return 'before';
  }

  if (current <= end) {
    return 'during';
  }

  return 'after';
}

export function getAppointmentUiState(appointment, now = new Date()) {
  if (appointment.status === 'cancelled') {
    return { key: 'cancelled', label: 'Odwołana', tone: 'cancelled' };
  }

  if (appointment.status === 'no_show') {
    return { key: 'no_show', label: 'Nie przyszła', tone: 'no-show' };
  }

  if (appointment.status === 'completed') {
    return { key: 'completed', label: 'Odbyta', tone: 'completed' };
  }

  const timingState = getAppointmentTimingState(appointment, now);

  if (timingState === 'before') {
    return { key: 'scheduled', label: 'Zaplanowana', tone: 'scheduled' };
  }

  if (timingState === 'during') {
    return { key: 'in_progress', label: 'Trwa', tone: 'in-progress' };
  }

  return { key: 'assumed_completed', label: 'Odbyta', tone: 'completed' };
}

export function isAppointmentResolved(appointment, now = new Date()) {
  if (['completed', 'cancelled', 'no_show'].includes(appointment.status)) {
    return true;
  }

  return now.getTime() > getAppointmentEnd(appointment).getTime();
}

export function getEditableStatuses(appointment, now = new Date()) {
  const timingState = getAppointmentTimingState(appointment, now);

  if (appointment.status === 'cancelled' || appointment.status === 'no_show' || appointment.status === 'completed') {
    return ['completed', 'no_show', 'cancelled'];
  }

  if (timingState === 'before') {
    return ['cancelled'];
  }

  if (timingState === 'during') {
    return ['no_show', 'cancelled'];
  }

  return ['completed', 'no_show', 'cancelled'];
}